import styleInject from 'style-inject';

var css_248z = ":root {\n\t--qd-more-action-popup-z-index: 4;\n}\n\n.MoreActionPopup-module_popup__JP-ho.MoreActionPopup-module_popup__JP-ho {\n\tz-index: var(--qd-more-action-popup-z-index);\n\n\tbox-shadow: var(--qd-popup-box-shadow);\n\tborder-radius: var(--qd-border-radius);\n\tborder: none;\n\tmargin-top: 4px;\n\n\tfont-family: var(--qd-font-family);\n\tbackground-color: var(--qd-color-dropdown-bg);\n}\n";
var styles = {"popup":"MoreActionPopup-module_popup__JP-ho"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
